import React from 'react';

interface Props {
  url: string;
}

export const StaticContentImage = (props: Props) => {
  const { url } = props;
  return (
    <div>
      <img src={url} className="w-full" />
    </div>
  );
};
